const _vehicleType = {
  VEHICLE: '1',
  HEAVY_EQUIPMENT: '2',
};

export default {
  data() {
    return {
      VEHICLE_TYPE: _vehicleType,
    };
  },
  methods: {}
};
